/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export class SetInitialConfiguration {
  static readonly type = '[address-widget] set intial configuration'

  constructor(
    public instanceId: string,
    public mode: string,
    public country: string,
    public locale: string,
    public token: string,
  ) {}
}

export class SetAppLoadingStatus {
  static readonly type = '[address-widget] set app loading status'

  constructor(public loading: boolean) {}
}

export class SetAppErrorMessage {
  static readonly type = '[address-widget] set app error message'

  constructor(
    public errorMessage: string | null,
    public instanceId: string | null,
  ) {}
}

export class SetEditorErrorMessage {
  static readonly type = '[address-widget] set editor error message'

  constructor(
    public errorMessage: string | null,
    public instanceId: string | null,
  ) {}
}
